import { axiosInstance } from '../services/axiosInstance';
import catchAsync from '../utils/catchAsync';

export const addToDo = catchAsync(async (body) => {
  const { data } = await axiosInstance.post(
    '/api/method/technoerp.services.assign_task',
    body
  );
  return data;
});

export const getToDo = catchAsync(async (id) => {
  //   return `/api/resource/ToDo?fields=["description","status","priority","date"]&allocated_to=${id}`;
  const { data } = await axiosInstance.get(
    `/api/resource/ToDo?fields=["name","description","status","priority","date"]&allocated_to=${id}`
  );
  return data;
});
export const deleteToDo = catchAsync(async (record) => {
  const { data } = await axiosInstance.delete(`/api/resource/ToDo/${record}`);
  return data;
});
export const getToDoDetails = catchAsync(async (id) => {
  const { data } = await axiosInstance.get(`/api/resource/ToDo/${id}`);
  return data;
});
